<template>
  <div class="row-card" :class="{ open }">
    <div class="row-head" @click="open = !open">
      <div class="row-status" :class="{ done }"></div>
      <div class="row-label">{{ title }}<span v-if="required" class="req-tag">Required</span></div>
      <div class="row-value" :class="{ muted: !summary }" :title="summary + (note ? ' ' + note : '')">{{ summary }}<span v-if="note" class="row-note">{{ note }}</span></div>
      <span class="chev">›</span>
    </div>
    <div class="row-body"><slot></slot></div>
  </div>
</template>

<script>
// Accordion configuration row — mirrors the design's .row-card.
export default {
  name: "AiwV2SetupCollapse",
  props: {
    title: { type: String, required: true },
    summary: { type: String, default: "" },
    note: { type: String, default: "" },
    required: { type: Boolean, default: false },
    done: { type: Boolean, default: false },
    defaultOpen: { type: Boolean, default: false },
  },
  data() {
    return { open: this.defaultOpen };
  },
};
</script>

<style scoped>
.row-card {
  background: var(--surface, #fff);
  border: 1px solid var(--border, #e4e4e4);
  border-radius: var(--r-lg, 10px);
  margin-bottom: 8px;
  overflow: hidden;
  transition: border-color .15s, box-shadow .15s;
}
.row-card:hover { border-color: var(--border-strong, #ccc); }
.row-card.open { border-color: var(--border-strong, #ccc); box-shadow: var(--shadow-sm, 0 1px 2px rgba(15,20,25,.03)); }
.row-head {
  display: flex; align-items: center;
  padding: 14px 18px;
  gap: 12px;
  cursor: pointer;
  user-select: none;
}
.row-status {
  width: 20px; height: 20px; border-radius: 50%;
  flex-shrink: 0;
  border: 1.5px solid var(--border-strong, #ccc);
  background: #fff;
  display: flex; align-items: center; justify-content: center;
  transition: all .15s;
}
.row-status.done { background: var(--pop-green, #25a97a); border-color: var(--pop-green, #25a97a); }
.row-status.done::after {
  content: "";
  width: 8px; height: 5px;
  border-left: 1.5px solid #fff;
  border-bottom: 1.5px solid #fff;
  transform: rotate(-45deg) translate(1px, -1px);
}
.row-label {
  font-weight: 600; font-size: 14px;
  display: flex; align-items: center; gap: 10px;
  color: var(--text, #052e33);
  min-width: 200px;
}
.req-tag {
  font-size: 9px; font-weight: 700; letter-spacing: .06em;
  background: var(--pop-orange-soft, #ffeddd); color: var(--pop-orange-deep, #b23d00);
  padding: 3px 7px; border-radius: 3px; text-transform: uppercase;
}
.row-value { flex: 1; min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: var(--text-2, #014751); font-size: 14px; font-weight: 500; }
.row-value.muted { color: var(--text-muted, #9aa6a8); font-weight: 400; }
.row-note { color: var(--text-3, #6b7b7e); font-weight: 500; margin-left: 6px; font-size: 12.5px; }
.chev { color: var(--text-muted, #9aa6a8); font-size: 16px; transition: transform .2s; }
.row-card.open .chev { transform: rotate(90deg); }
.row-body { display: none; padding: 6px 22px 20px; border-top: 1px solid var(--border, #e4e4e4); }
.row-card.open .row-body { display: block; }
</style>
